import { useEffect, useState } from 'react';
import { Image, Menu } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { Link, useLocation, useHistory } from 'react-router-dom';
import { Home, LogoWhite, ChangePassword, Logout } from '../../assets';
import { LOGIN_PATH } from '../../constant';
import './index.css';
const listPathSideBar = [
    '/',
    '/customer-management',
    '/change-password',
]
const SideBar = () => {
    const [activeKey, setActiveKey] = useState<string>();
    const location = useLocation();
    const history = useHistory();
    
    useEffect(() => {
        const pathIndex = listPathSideBar.indexOf(location.pathname);
        // Chỉ set activeKey nếu path có trong listPathSideBar, nếu không thì set undefined
        if (pathIndex !== -1) {
            setActiveKey(pathIndex.toString());
        } else {
            setActiveKey(undefined);
        }
    }, [location.pathname]);

    
    return (
        <div className='background'>
            <div className="flex flex-col h-full">
                {/* Logo Section */}
                <div className="flex justify-center py-4">
                    <Image
                        preview={false} 
                        src={LogoWhite}
                        className='logo_image'
                    />
                </div>

                {/* Main Menu Items */}
                <div>
                    <Menu
                        mode='inline'
                        onClick={(e) => setActiveKey(e.key.toString())}
                        theme="dark"
                        selectedKeys={activeKey !== undefined ? [activeKey] : []}
                        className="menu border-none"
                        defaultOpenKeys={['0']}
                    >
                        <Menu.Item key="0" className="menu_item" icon={
                            <img className="w-[24px] h-[24px]"
                                src={Home}></img>
                        } >
                            <Link to={'/'} className='text-sm'>Trang chủ</Link>
                        </Menu.Item>
                        <Menu.Item key="1" className="menu_item" icon={<UserOutlined />} >
                            <Link to={'/customer-management'} className='text-sm'>Quản lý khách hàng</Link>
                        </Menu.Item>
                    </Menu>
                </div>

                {/* Spacer */}
                <div className="flex-1"></div>

                {/* Bottom Menu Items */}
                <div>
                    <Menu
                        mode='inline'
                        onClick={(e) => setActiveKey(e.key.toString())}
                        theme="dark"
                        selectedKeys={activeKey !== undefined ? [activeKey] : []}
                        className="menu border-none"
                    >
                        <Menu.Item key="2" className="menu_item" icon={
                            <img className="w-[24px] h-[24px]"
                                src={ChangePassword}></img>
                        } >
                            <Link to={'/change-password'} className='text-sm'>Đổi mật khẩu</Link>
                        </Menu.Item>
                        <Menu.Item key="3" className="menu_item" icon={
                            <img className="w-[24px] h-[24px]"
                                src={Logout}></img>
                        }
                            onClick={() => {
                                localStorage.removeItem('auth');
                                localStorage.removeItem('refreshToken');
                                history.push(LOGIN_PATH);
                            }}
                        >
                           <p className='text-sm'>Đăng xuất</p> 
                        </Menu.Item>
                    </Menu>
                </div>

            </div>
        </div>
    );
};

export default SideBar;
